// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_style_checkbox__JmIIx","rotate":"Checkbox_style_rotate__yDVut"};